import { HelpText } from 'src/components/atoms/HelpText';
import { StyledCaseReportSectionTitle } from 'src/components/atomsLegacy';
import styled from 'styled-components';

export const ReportDetailsContainer = styled.div<{
  isVisible: boolean;
}>`
  position: relative;
  display: flex;
  flex-direction: column;
  max-width: ${(props) => (props.isVisible ? '300px' : 0)};
  height: 100%;
`;

export const Title = styled(StyledCaseReportSectionTitle)`
  text-transform: uppercase;
  margin: 10px 0 4px 0;
`;

export const PillContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 2;
  overflow-y: auto;
  gap: 16px;
  padding: 0 0 16px 0;
  height: 315px;
`;
export const DetailContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 10px;
`;
export const ButtonContainer = styled.div`
  display: grid;
  grid-gap: 12px;
`;

export const ReportDetailsToggleStyled = styled.div`
  position: absolute;
  top: 40px;
  right: 10px;

  img {
    width: 8px;
    height: 14px;
  }
`;

export const PlaceHolderText = styled.p`
  font-size: 16px;
  margin: 0;
`;

export const DateContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Error = styled.p`
  ${(props) => props.theme.newTypography.textStyleBodySmall};
  color: ${(props) => props.theme.newPalette.red.R300};
  margin-top: 6px;
  margin-bottom: 0;
`;

export const WarningMessageContainer = styled.div`
  background-color: ${(props) => props.theme.newPalette.yellow.Y100};
  margin-left: -40px;
  width: calc(100% + 60px);
  margin-bottom: 8px;
  padding: 16px;
`;

export const StyledHelpText = styled(HelpText)`
  gap: 8px;
`;
